(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-display-2"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-display').forEach(function (display) {
		display.querySelectorAll('[data-action]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				const input = display.querySelector('.product-display__qty-input');
				const val = parseInt(input.value) || 1;
				input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
			});
		});

		// Native one-time/subscribe selector built from the product's own
		// selling_plan_allocations, instead of relying on the Subscriptions
		// app embed script — which only loads on the product page template
		// and never runs when this snippet is used elsewhere (e.g. the
		// homepage banner).
		const sellingPlanInput = display.querySelector('input[name="selling_plan"]');
		const modeRadios = display.querySelectorAll('.purchase-mode-radio');

		const currentMode = function () {
			const checked = display.querySelector('input[name="purchase_mode"]:checked');
			return checked ? checked.value : 'subscribe';
		};

		const updatePurchaseState = function () {
			const mode = currentMode();

			// Expand the list belonging to the active mode, collapse the other.
			modeRadios.forEach(function (radio) {
				const row = radio.closest('.purchase-panel-mode');
				if (!row) return;
				const isActive = radio.value === mode;
				row.classList.toggle('purchase-panel-mode--active', isActive);
				const plans = row.querySelector('.purchase-panel-plans');
				if (plans) plans.classList.toggle('d-none', !isActive);
			});

			// `id` radios are shared by both lists (same variant, priced
			// differently per mode), so only the one matching the active
			// mode should ever drive the hidden selling_plan value.
			const checkedIdRadio = display.querySelector('input[name="id"]:checked');
			const matchesMode = checkedIdRadio && checkedIdRadio.dataset.purchaseMode === mode;
			if (sellingPlanInput) {
				sellingPlanInput.value = (mode === 'subscribe' && matchesMode) ? (checkedIdRadio.dataset.sellingPlanId || '') : '';
			}
		};

		modeRadios.forEach(function (radio) {
			radio.addEventListener('change', updatePurchaseState);
		});

		display.querySelectorAll('.purchase-panel-plans input[name="id"]').forEach(function (radio) {
			radio.addEventListener('change', function () {
				const modeRadio = display.querySelector('.purchase-mode-radio[value="' + this.dataset.purchaseMode + '"]');
				if (modeRadio) modeRadio.checked = true;
				updatePurchaseState();
			});
		});

		updatePurchaseState();

		// Reflect the selected variant in the URL so apps that watch for
		// `?variant=` changes (e.g. Shopify Subscriptions) can react to it.
		display.querySelectorAll('input[name="id"]').forEach(function (radio) {
			radio.addEventListener('change', function () {
				if (!this.checked) return;

				const url = new URL(window.location.href);
				url.searchParams.set('variant', this.value);
				window.history.replaceState({}, '', url);

				// Nudge MutationObservers relying on DOM changes to notice the URL update.
				const marker = document.createComment('variant-change');
				document.body.appendChild(marker);
				marker.remove();

				updatePurchaseState();
			});
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-display"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-display').forEach(function (display) {
		display.querySelectorAll('[data-action]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				const input = display.querySelector('.product-display__qty-input');
				const val = parseInt(input.value) || 1;
				input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
			});
		});

		// Force "subscription only" variants (e.g. trial offers) to hide the
		// one-time purchase option and default to the subscription plan.
		// The Subscriptions app injects its markup asynchronously after page
		// load, so wait for it via MutationObserver instead of assuming it's
		// already there.
		const embedBlock = display.querySelector('.subscriptions_app_embed_block');
		let forcedSubscriptionOnlyVariant = null;
		let applySubscriptionOnly = function () {};

		if (embedBlock) {
			const subscriptionOnlyIds = (embedBlock.dataset.subscriptionOnlyVariants || '')
				.split(',')
				.filter(Boolean);

			const subscriptionPlanLabels = {};
			(embedBlock.dataset.subscriptionPlanLabels || '')
				.split('||')
				.filter(Boolean)
				.forEach(function (entry) {
					const separatorIndex = entry.indexOf('::');
					if (separatorIndex === -1) return;
					subscriptionPlanLabels[entry.slice(0, separatorIndex)] = entry.slice(separatorIndex + 2);
				});

			// Maps variant id -> numeric selling_plan id of the custom plan we
			// created (with real per-cycle pricing) for that variant, since the
			// Subscriptions app's own plan can't be edited to charge differently
			// on the first cycle. See create_trial_plan.php.
			const subscriptionPlanIds = {};
			(embedBlock.dataset.subscriptionPlanIds || '')
				.split('||')
				.filter(Boolean)
				.forEach(function (entry) {
					const separatorIndex = entry.indexOf('::');
					if (separatorIndex === -1) return;
					subscriptionPlanIds[entry.slice(0, separatorIndex)] = entry.slice(separatorIndex + 2);
				});

			applySubscriptionOnly = function () {
				const activeVariantId = (display.querySelector('input[name="id"]:checked') || {}).value;
				const activeIsSubscriptionOnly = subscriptionOnlyIds.indexOf(activeVariantId) !== -1;

				// Replace the app's own purchase-options UI (one-time purchase +
				// its flat-price "Subscribe and Save") with a plain confirmation
				// line, since neither option reflects our real per-cycle pricing.
				embedBlock.querySelectorAll('section[data-variant-id]').forEach(function (section) {
					if (subscriptionOnlyIds.indexOf(section.dataset.variantId) === -1) return;

					const purchaseOptions = section.querySelector('.shopify_subscriptions_app_block_purchase_options');
					if (purchaseOptions && purchaseOptions.style.display !== 'none') {
						purchaseOptions.style.display = 'none';
					}

					// The app's own policy text ("Auto-renews, skip or cancel anytime.")
					// sits outside the purchase-options block, so fold it into our card
					// instead of leaving it floating on its own.
					const policyText = section.querySelector('.shopify_subscriptions_app_policy');
					if (policyText && policyText.style.display !== 'none') {
						policyText.style.display = 'none';
					}

					const customLabelText = subscriptionPlanLabels[section.dataset.variantId];
					if (customLabelText && !section.querySelector('.subscription-only-notice')) {
						const notice = document.createElement('div');
						notice.className = 'subscription-only-notice';

						const price = document.createElement('div');
						price.className = 'subscription-only-notice__price';
						price.textContent = customLabelText;
						notice.appendChild(price);

						if (policyText && policyText.textContent.trim()) {
							const policy = document.createElement('div');
							policy.className = 'subscription-only-notice__policy';
							policy.textContent = policyText.textContent.trim();
							notice.appendChild(policy);
						}

						section.appendChild(notice);
					}
				});

				// The app keeps a single shared hidden `selling_plan` input for every
				// variant. Only touch it while the subscription-only variant is the
				// one actually selected — otherwise we'd submit a selling plan that
				// doesn't belong to whatever variant the shopper is really buying.
				const hiddenInput = embedBlock.querySelector('.selected-selling-plan-id');
				if (activeIsSubscriptionOnly) {
					const customPlanId = subscriptionPlanIds[activeVariantId];
					if (hiddenInput && customPlanId) hiddenInput.value = customPlanId;
					forcedSubscriptionOnlyVariant = activeVariantId;
				} else if (forcedSubscriptionOnlyVariant) {
					if (hiddenInput) hiddenInput.value = '';
					forcedSubscriptionOnlyVariant = null;
				}
			};

			if (subscriptionOnlyIds.length) {
				applySubscriptionOnly();
				new MutationObserver(applySubscriptionOnly).observe(embedBlock, { childList: true, subtree: true });
			}
		}

		// Reflect the selected variant in the URL so apps that watch for
		// `?variant=` changes (e.g. Shopify Subscriptions) can react to it.
		display.querySelectorAll('input[name="id"]').forEach(function (radio) {
			radio.addEventListener('change', function () {
				if (!this.checked) return;

				const url = new URL(window.location.href);
				url.searchParams.set('variant', this.value);
				window.history.replaceState({}, '', url);

				// Nudge MutationObservers relying on DOM changes to notice the URL update.
				const marker = document.createComment('variant-change');
				document.body.appendChild(marker);
				marker.remove();

				if (embedBlock) applySubscriptionOnly();
			});
		});
	});
  } catch(e) { console.error(e); }
})();

})();
